<template>
  <v-dialog
    :max-width="maxWidth"
    :absolute="true"
    :origin=getCoordinates
    v-model="getActionShowDialog.show"
    content-class="rounded-lg actionDialog"
    persistent
    transition="scale-transition"
  >
    <v-card
      :max-width="maxWidth"
      class="pa-3 pa-3 no-scroll rounded-lg"
    >

      <viewConfigView
        v-if="getActionShowDialog.show"
        :viewconfig="getViewConfigForActionDialog"
        :object="getObjectForActionDialog"
        :operationid="getOperationIdForActionDialog"
        :editmode="true"
        :dialog="getActionShowDialog"
        :key="componentKey"
      />
    </v-card>
  </v-dialog>
</template>

<script>

import { mapGetters, mapMutations, mapActions } from "vuex";
import { isEmpty } from '../../api/utilities';
export default {
  components: {},
  data() {
    return {
      dialog: {
        show: null
      },
      componentKey: 0,
      maxWidth: 800
    }
  },
  computed: {
    ...mapGetters(["getViewConfigForActionDialog", "getObjectForActionDialog", "getActionShowDialog", "getOperationIdForActionDialog", "getOriginForActionDialog"]),

    getCoordinates() {
      console.log("GetCoordinates")
      var origin = this.getOriginForActionDialog
      if (!isEmpty(origin) && !isEmpty(origin.x) && !isEmpty(origin.y)) {
        var originString = origin.x.toString() + "px " + origin.y.toString() + "px"
        console.log("originString", originString)
        return originString
      }
      return ""
    }
  },
  methods: {

    changeView(buttonNumber) {

      this.$store.dispatch("changeViewState", buttonNumber);
    }

  }
};
</script>
  